import axios from "axios";
import { getMessage } from "@/utils/extractMessage";
import storageClient from "@/services/storageClient";
import i18n from "@/i18n";
import { isLocaleAllowed, migrateLocale } from "@/utils/allowedLocales";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import router from "@/router";

import store from "@/store";

dayjs.extend(utc);
dayjs.extend(timezone);

export function axiosSetup(vue) {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
  axios.defaults.headers["Accept"] = "application/json";
  axios.defaults.headers["Content-Type"] = "application/json";
  axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
  axios.defaults.headers["X-Timezone"] = dayjs.tz.guess();

  axios.interceptors.request.use((config) => {
    const token = storageClient.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const user = store.getters["auth/user"];

    const userLang = migrateLocale(user?.language);
    config.headers["Accept-Language"] = isLocaleAllowed(userLang) ? userLang : i18n.locale;

    return config;
  });

  axios.interceptors.response.use(
    (r) => r,
    (e) => {
      vue.notify({
        group: "notifications",
        title: "Something went wrong",
        text: getMessage(e),
        type: "error"
      });

      if (e?.response?.status === 401) {
        storageClient.removeToken();
        router.push({ name: "SignIn" });
      }

      return Promise.reject(e);
    }
  );
}
